import { Collapse } from 'antd'

import _map from 'lodash/map'

import Paragraph from 'components/Paragraph'

import Styled from './styled'

export default function SectionFAQ({ data }) {
  return (
    <Styled>
      <div className="faq-container">
        <div className="header-container">
          <div className="header">
            <Paragraph>คำถามที่พบบ่อย</Paragraph>
          </div>
        </div>
        <div className="faq-content">
          <Collapse className="faq-list" bordered={false} expandIconPosition="right">
            {_map(data, (item, index) => {
              return (
                <Collapse.Panel
                  className="title"
                  key={index}
                  header={
                    <div className="question">
                      <Paragraph>{item.question}</Paragraph>
                    </div>
                  }
                >
                  <div className="content">
                    <Paragraph>
                      <div dangerouslySetInnerHTML={{ __html: item.answer }} />
                    </Paragraph>
                  </div>
                </Collapse.Panel>
              )
            })}
          </Collapse>
        </div>
      </div>
    </Styled>
  )
}
